import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "../components/site/PageHeader";
import { ProjectDialog } from "../components/site/ProjectDialog";
import { CtaBand } from "../components/home/CtaBand";
import { useProjects } from "../lib/useProjects";
import { img } from "../lib/api";

export default function Portfolio() {
  const { items, loading } = useProjects("wedding");
  const [open, setOpen] = useState(null);
  const photos = items.flatMap((p) => (p.images || []).map((u) => ({ src: u, project: p })));

  return (
    <main data-testid="portfolio-page" className="bg-cream">
      <PageHeader testid="portfolio-header" eyebrow="Portfolio · Wedding florist" lines={["Matrimoni", "fioriti"]}
        intro="Ogni matrimonio è un progetto a sé: la location, la luce, la vostra storia. Qui raccolgo le foto dei miei eventi, aggiornate di volta in volta." />
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pb-28">
        {loading ? (
          <p className="text-ash">Caricamento…</p>
        ) : photos.length === 0 ? (
          <p data-testid="portfolio-empty" className="text-ash">Nuovi progetti in arrivo.</p>
        ) : (
          <div data-testid="portfolio-gallery" className="columns-1 sm:columns-2 lg:columns-3 gap-5">
            {photos.map((ph, i) => (
              <motion.button
                key={ph.src + i}
                type="button"
                onClick={() => setOpen(ph.project)}
                data-testid={`portfolio-photo-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.1 }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: (i % 3) * 0.07 }}
                className="group relative block w-full mb-5 break-inside-avoid overflow-hidden bg-sand"
              >
                <img src={img(ph.src)} alt={ph.project.title} loading="lazy"
                  className="w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]" />
              </motion.button>
            ))}
          </div>
        )}
      </div>
      <CtaBand />
      <ProjectDialog project={open} onClose={() => setOpen(null)} />
    </main>
  );
}
